export const API_PATCH_TUBE = 'API_PATCH_TUBE';
export const API_PATCH_TUBE_SUCCESS = 'API_PATCH_TUBE_SUCCESS';
export const API_PATCH_TUBE_FAIL = 'API_PATCH_TUBE_FAIL';

export const API_PATCH_MULTIPLE_TUBE = 'API_PATCH_MULTIPLE_TUBE'
export const API_PATCH_MULTIPLE_TUBE_SUCCESS = 'API_PATCH_MULTIPLE_TUBE_SUCCESS'
export const API_PATCH_MULTIPLE_TUBE_FAIL = 'API_PATCH_MULTIPLE_TUBE_FAIL'

export const API_POST_TUBE = 'API_POST_TUBE';
export const API_POST_TUBE_SUCCESS = 'API_POST_TUBE_SUCCESS';
export const API_POST_TUBE_FAIL = 'API_POST_TUBE_FAIL';

export const API_DELETE_TUBE = 'API_DELETE_TUBE';
export const API_DELETE_TUBE_SUCCESS = 'API_DELETE_TUBE_SUCCESS';
export const API_DELETE_TUBE_FAIL = 'API_DELETE_TUBE_FAIL';

export const API_POST_REUSABLE_TUBE = 'API_POST_REUSABLE_TUBE';
export const API_POST_REUSABLE_TUBE_SUCCESS = 'API_POST_REUSABLE_TUBE_SUCCESS';
export const API_POST_REUSABLE_TUBE_FAIL = 'API_POST_REUSABLE_TUBE_FAIL';

export const API_GET_MISSING_VOLUME_TUBE = 'API_GET_MISSING_VOLUME_TUBE';
export const API_GET_MISSING_VOLUME_TUBE_SUCCESS = 'API_GET_MISSING_VOLUME_TUBE_SUCCESS';
export const API_GET_MISSING_VOLUME_TUBE_FAIL = 'API_GET_MISSING_VOLUME_TUBE_FAIL';
